var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: {
        "class-name": "profile-field-modal",
        active: _vm.displayModal,
        title: _vm.title,
        "disable-scroll": _vm.disableScroll,
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "subtitle",
          fn: function () {
            return [
              _vm.field && _vm.field.isSystem
                ? _c("div", { staticClass: "system-label" }, [
                    _vm._v("Системное"),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: {
                  label: "Сохранить",
                  color: "primary",
                  size: "large",
                  disabled: _vm.pending,
                  pending: _vm.pending,
                },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "field-form" },
        [
          _c(
            "div",
            { staticClass: "form-group field-form__tab" },
            [
              _c("c-input", {
                attrs: {
                  type: "select",
                  label: "Вкладка",
                  searchable: true,
                  items: _vm.tabsList,
                },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
          !_vm.field
            ? _c(
                "div",
                { staticClass: "form-group field-form__creation-type" },
                [
                  _c("c-switcher", {
                    staticClass: "h-switcher",
                    attrs: { type: "group", items: _vm.creationTypes },
                    model: {
                      value: _vm.creationType,
                      callback: function ($$v) {
                        _vm.creationType = $$v
                      },
                      expression: "creationType",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(_vm.activeForm, {
            ref: "form",
            tag: "component",
            attrs: {
              "profile-id": _vm.profileId,
              field: _vm.field,
              fields: _vm.fields,
              "save-field-data": _vm.saveFieldData,
              "save-dictionary": _vm.saveDictionary,
            },
            on: {
              submitted: _vm.onSubmit,
              pending: function ($event) {
                _vm.pending = $event
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }